import RestResource from '../rest.service';

export default class PicturesService extends RestResource {
  map(entity) {
    return {
      description: entity.description,
    };
  }

  constructor() {
    super('pictures');
  }
}
